import {Routes} from "@angular/router";
import {WorkflowPartnerOneUpgradeCuComponent} from "./workflow-partner-one-upgrade-cu.component";

export const workflowPartnerOneUpgradeCuRouting: Routes = [
    { path: 'partner/upgrade-cu/:aid', component: WorkflowPartnerOneUpgradeCuComponent, children: [
            { path: 'contact', component: WorkflowPartnerOneUpgradeCuComponent },
            { path: 'address', component: WorkflowPartnerOneUpgradeCuComponent },
            { path: 'payment', component: WorkflowPartnerOneUpgradeCuComponent },
            { path: 'checkout', component: WorkflowPartnerOneUpgradeCuComponent },
            { path: 'complete', component: WorkflowPartnerOneUpgradeCuComponent },
            { path: '', redirectTo: 'contact', pathMatch: 'full' },
    ]},
]
